module.exports = __webpack_public_path__ + "img/smile3.a9e0184b.png";